import React from "react";
import { Space } from "antd";
import { AxSwitch, AxDivider, AxButton } from "@dynata/axiom3";

class Switch extends React.Component {
  render() {
    return (
      <div className="section" id="switch">
        <h3>Switch</h3>
        <p>Switching selector</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxSwitch />`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/switch/#API"
                >
                  https://ant.design/components/switch/#API
                </AxButton>
              </p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>size</td>
                  <td>Switch size, default is medium</td>
                  <td>small | medium | large</td>
                  <td></td>
                </tr>
                <tr>
                  <td>checked</td>
                  <td>Determine whether the switch is checked</td>
                  <td>boolean</td>
                  <td></td>
                </tr>
                <tr>
                  <td>autoFocus</td>
                  <td>Whether get focus when component mounted</td>
                  <td>boolean</td>
                  <td>false</td>
                </tr>
                <tr>
                  <td>checked</td>
                  <td>Determine whether the Switch is checked</td>
                  <td>boolean</td>
                  <td>false</td>
                </tr>
                <tr>
                  <td>checkedChildren</td>
                  <td>The content to be shown when the state is checked</td>
                  <td>ReactNode</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>className</td>
                  <td>The additional class to Switch</td>
                  <td>string</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>defaultChecked</td>
                  <td>Whether to set the initial state</td>
                  <td>boolean</td>
                  <td>false</td>
                </tr>
                <tr>
                  <td>disabled</td>
                  <td>Disable switch</td>
                  <td>boolean</td>
                  <td>false</td>
                </tr>
                <tr>
                  <td>loading</td>
                  <td>Loading state of switch</td>
                  <td>boolean</td>
                  <td>false</td>
                </tr>
                <tr>
                  <td>size</td>
                  <td>
                    The size of the Switch, options: <code>default</code>{" "}
                    <code>small</code>
                  </td>
                  <td>string</td>
                  <td>
                    <code>default</code>
                  </td>
                </tr>
                <tr>
                  <td>unCheckedChildren</td>
                  <td>The content to be shown when the state is unchecked</td>
                  <td>ReactNode</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>onChange</td>
                  <td>Trigger when the checked state is changing</td>
                  <td>function(checked: boolean, event: Event)</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>onClick</td>
                  <td>Trigger when clicked</td>
                  <td>function(checked: boolean, event: Event)</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/switch/#API"
                      >
                        {`<Switch />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>

            <pre>{`<AxSwitch />
<AxSwitch disabled defaultChecked={true} />
<AxSwitch defaultChecked={true} />`}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Small | Large | Medium
        </AxDivider>

        <Space direction="vertical" size={30}>
          <Space>
            <AxSwitch size="large" />
            <AxSwitch size="large" disabled checked />
            <AxSwitch size="large" defaultChecked={true} />
          </Space>

          <Space>
            <AxSwitch />
            <AxSwitch disabled defaultChecked={true} />
            <AxSwitch defaultChecked={true} />
          </Space>

          <Space>
            <AxSwitch size="small" />
            <AxSwitch size="small" defaultChecked={true} />
            <AxSwitch size="small" defaultChecked={true} disabled />
            <AxSwitch size="small" disabled />
          </Space>
        </Space>
      </div>
    );
  }
}
export default Switch;
